module.exports = __webpack_public_path__ + "img/Brasao.7b6ecf73.png";